import { useEffect, useState } from "react"
import { Button, TextField, Grid, Typography, InputLabel, FormControlLabel, Checkbox, MenuItem, LinearProgress } from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router";
import progs from '../resources/prog'
import config from '../config.json';
import { apiRequest } from '../functions/apiRequest';
import { useLocation } from 'react-router-dom';
import CustomAliceCarousel from "../customComponents/customAliceCarousel";


const gridStyle = {
  border: '1px solid #ccc', // Grey outline
  boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.5)', // Shadow
  padding: '16px', // Add padding for spacing    
  cursor: 'pointer',
};

const noEmployeeDrives = ['3']
const TNCPage = (props) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const driveId = queryParams.get('drive_id');
  const isCouponDrive = queryParams.get('coupon_drive') === 'true';
  const isFestiveDrive = queryParams.get('festive_drive') === 'true';
  const company = decodeURIComponent(queryParams.get('company'));
  const [isLoading, setisLoading] = useState(true)
  const [others, setOthers] = useState(true)
  const [programs, setPrograms] = useState([])
  const [ProgramEvents, setProgramEvents] = useState([])
  const [val, setVal] = useState(false)
  const [state, setState] = useState(false)
  const [selectedIdx, setSelectedIdx] = useState(-1);
  const [category, setCategory] = useState('')
  const navigate = useNavigate()

  const [error, setError] = useState(false)
  const stringifiedUser = localStorage.getItem('user');
  const user = JSON.parse(stringifiedUser);

  const initialFormData = Object.freeze({
    amount: '',
    email_id: '',
    name: '',
    program: '',
    event: '',
    number: '',
    pan: '',
    address: '',
  });
  const [formData, updateFormData] = useState(initialFormData);


  const handleSelect = (categoryName) => {
    let idx = programs.findIndex(category => { return category.name === categoryName })
    setSelectedIdx(idx);
    updateFormData({
      ...formData,
      // Trimming any whitespace
      note: categoryName,
    });
  }
  const handleChange = (e) => {
    updateFormData({
      ...formData,
      // Trimming any whitespace
      [e.target.name]: e.target.value,
    });
  };

  async function changeProgram(e) {
    try {
      if (e.target.value !== 0 && e.target.value.ProgramId) {
        const data = await apiRequest('get', null, `/program/events/view?program_id=${e.target.value.ProgramId}`);
        setProgramEvents(data[0].Event)
        if (data[0].Event.length > 0 && !isCouponDrive) {
          setOthers(false)
        }
      } else {
        setOthers(true)
      }
    } catch (e) {
      //
    }
  }


  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function displayRazorpay() {
    const res = await loadScript(
      "https://checkout.razorpay.com/v1/checkout.js"
    );

    if (!res) {
      alert("Razorpay SDK failed to load. Are you online?");
      return;
    }

    const result = await axios.post(process.env.REACT_APP_API_URL + "/api/donate", { 'amount': formData.amount });

    if (!result) {
      alert("Server error. Are you online?");
      return;
    }

    const { amount, id: order_id, currency } = result.data;

    const options = {
      key: "rzp_live_VtT38XAZOqi6MW", // Enter the Key ID generated from the Dashboard
      amount: amount.toString(),
      currency: currency,
      name: `${process.env.REACT_APP_TITLE} (Gift of Time Foundation)`,
      description: "Donation",
      image: '',
      order_id: order_id,
      handler: async function (response) {
        const data = {
          orderCreationId: order_id,
          razorpayPaymentId: response.razorpay_payment_id,
          razorpayOrderId: response.razorpay_order_id,
          razorpaySignature: response.razorpay_signature,
        };
        navigate({
          pathname: 'thankyou',
          state: {
            detail: data,
            form: formData,
            name: user ? (user.first_name + ' ' + user.last_name) : '',
            email: user ? user.email_id : '',
            contact: user ? user.mobile_number : '',
            user_id: user ? user.id : ''
          }
        })

      },
      theme: {
        color: config[process.env.REACT_APP_HOST_NAME].css.websiteColor,
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  const handleChangee = (e) => {
    setVal(!val)
    setState(!state)
  }

  const fetchPrograms = async () => {
    try {
      let allPrograms = await apiRequest('GET', null, '/programs/list/view');
      let programIdsToDisplay = process.env.REACT_APP_PROGRAM_DONATION_LIST.split(',');
      let programsToDisplay = allPrograms.filter(program => { return (programIdsToDisplay.includes(`${program.ProgramId}`)) });
      programsToDisplay.push({ ProgramName: "Others", ProgramId: 0 });
      setPrograms(programsToDisplay);
    } catch (err) {
      return [];
    }
  }

  const fetchCouponPrograms = async () => {
    try {
      const data = await apiRequest('get', null, `/coupon/details/${driveId}`);
      setPrograms(data.categories)
    } catch (err) {
      return []
    }
  }

  useEffect(() => {
    if (isCouponDrive || isFestiveDrive) {
      fetchCouponPrograms();
      setCategory('Coupon Donation Drive')
    } else {
      fetchPrograms();
    }
    setisLoading(false);
    // eslint-disable-next-line
  }, [])



  if (!isLoading) {
    return (
      <div style={{ justifyContent: 'center', display: 'flex' }}>
        <Grid container spacing={2} justifyContent="center" style={{ fontFamily: 'Raleway', textAlign: 'center', padding: '4vw' }}>
          <Grid item xs={12} md={3} hidden={isFestiveDrive}></Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={2} justifyContent="center" style={{ fontFamily: 'Raleway', textAlign: 'center' }}>
              <Grid item xs={12}>
                <Typography style={{ fontSize: 30, fontFamily: 'Raleway' }}>
                  {!isFestiveDrive && "Donate generously to help us build India's largest time bank"}
                  {isFestiveDrive && "Skip the sweets, make a difference – donate for a brighter Diwali!"}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography style={{ fontSize: 30, fontFamily: 'Raleway' }}>Your donation qualifies for 80G tax rebate </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography style={{ fontSize: 20, fontFamily: 'Raleway' }}>Please read the terms and conditions attached below!</Typography>
              </Grid>
              <Grid item xs={12}>
                <a href='/terms' target='_blank' rel='noopener noreferrer'> Terms and conditions</a>
              </Grid>
              <Grid item xs={12}>
                <a href='/refund-policy' target='_blank' rel='noopener noreferrer'>Fees and Refund Policy</a>
              </Grid>
              <Grid item xs={12}>
                <a href='/privacy-policy' target='_blank' rel='noopener noreferrer'>Privacy Policy</a>
              </Grid>
              <Grid item xs={12} md={12}>
                <FormControlLabel
                  control={
                    <Checkbox
                      name='checked'
                      defaultChecked={state}
                      onChange={handleChangee}
                      style={{ fontFamily: 'Raleway', color: config[process.env.REACT_APP_HOST_NAME].css.buttonColor }}
                    />
                  }
                  label="By clicking proceed, you agree to our terms of use, fees and refund policy and that you have read and accepted the privacy policy"
                />
              </Grid></Grid></Grid>
          <Grid item xs={12} md={12} hidden={!isFestiveDrive}>
            <Grid container justifyContent='center' >
              {programs && programs.map((category, idx) => <Grid item xs={12} md={3} key={category.name} style={{ ...gridStyle, backgroundColor: idx === selectedIdx ? 'rgba(0, 255, 0, 0.4)' : 'transparent' }} onClick={() => { handleSelect(category.name) }}>
                {category.images && <CustomAliceCarousel images={category.images} autoPlayInterval={2000} />}
                <Typography style={{ fontSize: '20pt', textAlign: 'center', fontFamily: 'Raleway' }}>
                  {category.name}
                </Typography>
              </Grid>)}
            </Grid>
          </Grid>
          <Grid item xs={12} md={3} hidden={isFestiveDrive}></Grid>
          <Grid item xs={12} md={6}>
            <Grid container spacing={2} justifyContent="center" style={{ fontFamily: 'Raleway', textAlign: 'center' }}>
              <Grid item xs={12} md={6}>
                <Grid container justifyContent="center" spacing={2}>
                  <Grid item xs={12} md={12} hidden={isFestiveDrive}>
                    <TextField
                      select
                      label='WHICH CATERGORY ARE YOU DONATING FOR?'
                      fullWidth
                      placeholder='Who is your donation for?'
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={category ? category : ''}
                      onChange={(e) => { handleChange(e); setCategory(e.target.value) }}
                      id='category'
                      name='category'
                    >
                      {progs && progs.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                          {option.label}
                        </MenuItem>

                      ))}
                    </TextField>
                  </Grid>

                  <Grid item xs={12} md={12} hidden={isFestiveDrive}>
                    <TextField
                      select
                      label='CHOOSE YOUR PROGRAM'
                      fullWidth
                      placeholder='Who is your donation for?'
                      InputLabelProps={{
                        shrink: true,
                      }}
                      id='program'
                      name='program'
                      defaultValue={''}
                      onChange={handleChange}
                      onClick={changeProgram}
                    >
                      {programs && programs.map((option) => (
                        <MenuItem key={option.ProgramId} value={option}  >
                          {option.ProgramName}
                        </MenuItem>
                      ))
                      }
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={12} hidden={others}>
                    <TextField
                      select
                      label='CHOOSE YOUR EVENT'
                      fullWidth
                      placeholder='Who is your donation for?'
                      InputLabelProps={{
                        shrink: true,
                      }}
                      id='event'
                      name='event'
                      defaultValue={''}
                      onChange={handleChange}
                    >
                      {ProgramEvents && ProgramEvents.map((option2) => (
                        <MenuItem key={option2.EventID} value={option2}>
                          {option2.Title}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={12} hidden={isFestiveDrive}>
                    <TextField
                      label='Note'
                      fullWidth
                      placeholder='Note'
                      InputLabelProps={{
                        shrink: true,
                      }}
                      id='note'
                      name='note'
                      onChange={handleChange}
                    >

                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <InputLabel style={{ textAlign: 'left' }}>Amount (in ₹)</InputLabel>
                <TextField
                  variant="outlined"
                  required
                  size='small'
                  fullWidth
                  style={{ height: 40 }}
                  id="amount"
                  name="amount"
                  onChange={handleChange}
                />
              </Grid>

              <Grid item xs={12} hidden={isFestiveDrive || (!isCouponDrive || noEmployeeDrives.includes(driveId))}>
                <Typography style={{ textAlign: 'center' }}>Your donation {formData.amount !== '' ? `of ₹${formData.amount}` : ''} will be matched by {company}! doubling your impact{formData.amount !== '' ? ` and making your effective donation ₹${formData.amount * 2}!` : '!'}</Typography>
              </Grid>
              {error ?

                <Grid item xs={12}>
                  Please fill out the amount field
                </Grid>

                : ''
              }


              <Grid item xs={12}>
                {val ?
                  <Button onClick={() => {
                    if (formData.amount !== '') {
                      displayRazorpay()
                    } else {
                      setError(true)
                    }
                  }} style={{ backgroundColor: config[process.env.REACT_APP_HOST_NAME].css.websiteColor, color: 'white' }}>Pay</Button> : ''}
              </Grid>
              <br></br>
            </Grid>
          </Grid>
        </Grid>
      </div>
    )
  }
  else {

    return (
      <div style={{ marginTop: 20, textAlign: 'center' }}>
        <img alt={'logo'} style={{ height: 350, width: 300 }} src={`${process.env.REACT_APP_R2_URL}/general/time_creds_logo.png`} />
        <LinearProgress />

      </div>

    )

  }




}

export default TNCPage 